import React, { memo, useState } from 'react';

import PropTypes from 'prop-types';
import { trim, size } from 'lodash';
import { useAsyncDebounce } from 'react-table';
import TextField from '@mui/material/TextField';

import { TIMEOUT, MIN_LENGTH } from '@constants/FILTERS_OPTIONS';

const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => {
  const [value, setValue] = useState(filterValue);

  /**
   * Used to store filter
   * @param {string} value get value
   */
  const handleUpdateFilter = useAsyncDebounce((value) => {
    if (size(value) >= MIN_LENGTH || size(value) === 0) {
      setFilter(trim(value));
    }
  }, TIMEOUT);

  return (
    <TextField
      label="Filter"
      variant="outlined"
      value={value || ''}
      onChange={(e) => {
        setValue(e.target.value);
        handleUpdateFilter(e.target.value);
      }}
    />
  );
};

DefaultColumnFilter.defaultProps = {
  column: {
    filterValue: '',
  },
};

DefaultColumnFilter.propTypes = {
  column: PropTypes.shape({
    filterValue: PropTypes.string,
    id: PropTypes.string.isRequired,
    setFilter: PropTypes.func.isRequired,
  }),
};

export default memo(DefaultColumnFilter);
